import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LinearProgress, Link, Stack, Typography } from '@mui/material';

import { useRequestState } from '@app/hooks';
import { ProductCard } from '@app/components';
import { Strings } from '@app/constants';
import { PATH_DASHBOARD } from '@app/routes/paths';
import { selectRecentViewedRecipes } from '@app/modules/common';
import { selectNewRecipes, selectRecommendations } from '../selectors';

const HomeScreen = () => {
  const navigation = useNavigate();

  const { loading: recommendationsLoading, data: recommendations } = useRequestState({
    stateSelector: selectRecommendations,
    errorShown: true,
  });

  const { loading, data: newRecipes } = useRequestState({
    stateSelector: selectNewRecipes,
    errorShown: true,
  });

  const recentViewData = useSelector(selectRecentViewedRecipes);

  const data = [
    {
      collectionName: 'Recently Viewed',
      recipes: recentViewData,
      loading: false,
    },
    {
      collectionName: 'Recommended',
      recipes: recommendations,
      loading: recommendationsLoading,
    },
    {
      collectionName: 'New Recipes',
      recipes: newRecipes,
      loading: loading,
    },
  ];

  const RenderItem = ({ item }: any, key: number) => {
    return (
      <ProductCard
        key={key}
        image={item?.image}
        dishName={item.label}
        cookingTime={`${item.totalTime} min`}
        ratings={item?.ratings || 'No Rating Yet'}
        description={item.label || item.description}
        id={item?.uri}
        onClick={() => navigation(PATH_DASHBOARD.recipeDetailsScreen, { state: item })}
      />
    );
  };

  return (
    <Stack>
      {data?.map((collection, index) => {
        return collection.loading ? (
          <LinearProgress sx={{ mt: 25 }} />
        ) : (
          collection?.recipes?.length !== 0 && (
            <Stack key={`${collection?.collectionName}-${index}`}>
              <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between', my: 2 }}>
                <Typography variant="h5">{collection?.collectionName}</Typography>
                <Typography
                  onClick={() => navigation(PATH_DASHBOARD.viewAllScreen, { state: collection })}
                >
                  <Link color="primary" sx={{ fontWeight: 'bold', cursor: 'pointer' }}>
                    {Strings.button.viewAll}
                  </Link>
                </Typography>
              </Stack>
              <Stack
                style={{
                  flexDirection: 'row',
                  gap: 15,
                  overflowX: 'auto',
                  width: '100%',
                  scrollbarWidth: 'none',
                  paddingBottom: 5,
                }}
              >
                {collection?.recipes
                  ?.slice(0, 10)
                  .map((item: any, index: number) => <RenderItem key={index} item={item} />)}
              </Stack>
            </Stack>
          )
        );
      })}
    </Stack>
  );
};

export { HomeScreen };
